module.exports = __webpack_public_path__ + "static/media/storesBanner.11533e32.png";